'use client';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import { Fragment, PropsWithChildren } from 'react';
import { GlobalStyles } from '@mui/material';
import { useInView } from 'react-intersection-observer';

const Recaptcha = ({ children }: PropsWithChildren) => {
  const { ref, inView } = useInView({
    triggerOnce: true,
    rootMargin: '100px',
  });
  if (!process.env.NEXT_PUBLIC_RECAPTCHA_SITE_KEY) return children;

  const Container = inView
    ? GoogleReCaptchaProvider
    : (props: PropsWithChildren) => <Fragment>{props.children}</Fragment>;

  return (
    <div ref={ref}>
      <GlobalStyles
        styles={{
          '.grecaptcha-badge': {
            visibility: 'hidden !important',
          },
        }}
      />
      <Container
        reCaptchaKey={process.env.NEXT_PUBLIC_RECAPTCHA_SITE_KEY!}
        scriptProps={{
          async: true,
          defer: true,
          appendTo: 'body',
        }}
      >
        {children}
      </Container>
    </div>
  );
};

export default Recaptcha;
